import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductFinishMaterials1 extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateFinishMaterials);

    // Set up modal functionality
    this.setupModalEvents();
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateFinishMaterials);

    // Clean up modal events
    this.cleanupModalEvents();
  }

    setupModalEvents() {
    // Clean up first to prevent duplicate listeners
    this.cleanupModalEvents();

    // Add click listeners to finish items
    this.addEventListener('click', this.handleFinishItemClick);

    // Add modal close listeners
    const modal = this.querySelector('#finish-modal-1');
    if (modal) {
      const closeBtn = modal.querySelector('.finish-modal-close');
      const backdrop = modal.querySelector('.finish-modal-backdrop');

      closeBtn?.addEventListener('click', this.closeModal);
      backdrop?.addEventListener('click', this.closeModal);

      // Add escape key listener
      document.addEventListener('keydown', this.handleEscapeKey);
    }
  }

  /**
   * @param {KeyboardEvent} event
   */
  handleEscapeKey = (event) => {
    if (event.key === 'Escape') {
      this.closeModal();
    }
  };

    cleanupModalEvents() {
    this.removeEventListener('click', this.handleFinishItemClick);
    document.removeEventListener('keydown', this.handleEscapeKey);

    const modal = this.querySelector('#finish-modal-1');
    if (modal) {
      const closeBtn = modal.querySelector('.finish-modal-close');
      const backdrop = modal.querySelector('.finish-modal-backdrop');

      closeBtn?.removeEventListener('click', this.closeModal);
      backdrop?.removeEventListener('click', this.closeModal);
    }
  }

      /**
   * @param {Event} event
   */
  handleFinishItemClick = (event) => {
    if (!event.target) return;
    const finishItem = /** @type {HTMLElement|null} */ (/** @type {Element} */ (event.target).closest('.finish-materials-clickable'));
    if (!finishItem) return;

    event.preventDefault();

    const name = finishItem.dataset.finishName || '';
    const image = finishItem.dataset.finishImage || '';
    const description = finishItem.dataset.finishDescription || '';

    this.openModal(name, image, description);
  };

  /**
   * @param {string} name
   * @param {string} image
   * @param {string} description
   */
  openModal = (name, image, description) => {
    const modal = this.querySelector('#finish-modal-1');
    if (!modal) return;

    const modalImage = /** @type {HTMLImageElement|null} */ (modal.querySelector('.finish-modal-image'));
    const modalName = modal.querySelector('.finish-modal-name');
    const modalDescription = /** @type {HTMLElement|null} */ (modal.querySelector('.finish-modal-description'));

    if (modalImage && image) {
      modalImage.src = image;
      modalImage.alt = name || '';
    }

    if (modalName) {
      modalName.textContent = name || '';
    }

    if (modalDescription) {
      if (description && description.trim()) {
        modalDescription.textContent = description;
        modalDescription.style.display = 'block';
      } else {
        modalDescription.textContent = '';
        modalDescription.style.display = 'none';
      }
    }

    /** @type {HTMLElement} */ (modal).style.display = 'flex';
    document.body.style.overflow = 'hidden';
  };

  closeModal = () => {
    const modal = this.querySelector('#finish-modal-1');
    if (modal) {
      /** @type {HTMLElement} */ (modal).style.display = 'none';
      document.body.style.overflow = '';
    }
  };

  /**
   * @param {VariantUpdateEvent} event
   */
  updateFinishMaterials = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newElement = event.detail.data.html.querySelector('product-finish-materials-1');

    if (!newElement) {
      this.classList.add('product-finish-materials--hidden');
      return;
    }

    // Update the content first
    morph(this, newElement, { childrenOnly: true });

    // Re-setup modal events after content update
    this.setupModalEvents();

    // Then update visibility based on the new element's class
    if (newElement.classList.contains('product-finish-materials--hidden')) {
      this.classList.add('product-finish-materials--hidden');
    } else {
      this.classList.remove('product-finish-materials--hidden');
    }
  };
}

if (!customElements.get('product-finish-materials-1')) {
  customElements.define('product-finish-materials-1', ProductFinishMaterials1);
}
